import { ReactNode } from 'react';
import styled from 'styled-components';

import { Grid } from 'coreOld/elements';

export const Container = styled.div`
  display: -ms-grid;
  display: grid;
  -ms-grid-columns: 1fr 1fr;
  grid-template-columns: 1fr 1fr;
  column-gap: 4em;
  padding: 10px 30px;
`;

type GridContainerProps = { isDisabled?: boolean };

export const GridContainer = styled(Grid)<GridContainerProps>`
  padding: 10px 14px;
  margin: 0;

  input {
    text-align: ${({ isDisabled }) => (isDisabled ? 'right' : 'inherit')};
  }
`;

export const GridItem = styled(Grid)`
  margin-right: 4em;
`;

export const Section = styled.div``;

export const SectionTitle = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0px 30px;
  align-items: center;
  font-weight: 600;
  margin-top: 20px;
`;

export const WrapperNotification = styled.div`
  padding: 10px 30px;
`;

type ButtonWrapperProps = { onClick?: () => void; children?: ReactNode };

export const ButtonWrapper = styled.div<ButtonWrapperProps>`
  display: flex;
  justify-content: space-between;
`;
